module.exports = __webpack_public_path__ + "img/Dante.15d07770.jpg";